import { render, staticRenderFns } from "./c-register-form.vue?vue&type=template&id=0f98be97&"
import script from "./c-register-form.vue?vue&type=script&lang=js&"
export * from "./c-register-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports